import './WeightRating.css';

import React, { useState } from 'react';
import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import { styled } from '@mui/system';
import CircleIcon from '@mui/icons-material/Circle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import { generateClassName } from '../../../b2b-common/helpers';
import FieldComponent from '../../../b2b-common/FieldComponent';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const CustomRating = styled(Rating)({
    '& .MuiRating-iconFilled': {
        color: '#3233c1',
    },
    '& .MuiRating-iconHover': {
        color: '#17368b',
    },
});

export const WeightRatingField = ({ weight }) => {
    const { t } = useB2BTranslation('b2b-plans');
    return (
        <FieldComponent
            label={t('Weight / Relevance')}
            component={
                <CustomRating
                    name="weight-rating"
                    value={weight / 2} // Map 0-10 to 0-5
                    precision={0.5}
                    max={5}
                    icon={<CircleIcon fontSize="inherit" />}
                    emptyIcon={<CircleOutlinedIcon fontSize="inherit" />}
                    readOnly={true}
                />
            }
            className='weight-rating-field' />
    );
};

const WeightRating = ({ initialWeight, onWeightChange, className = null }) => {
    const [weight, setWeight] = useState(initialWeight);

    const handleChange = (event, newValue) => {
        const mappedValue = newValue * 2; // Map 0-5 to 0-10
        setWeight(mappedValue);
        onWeightChange(mappedValue);
    };

    return (
        <Box component="fieldset" mb={3} borderColor="transparent" className={generateClassName('weight-rating', '-container', className)}>
            <CustomRating
                name="weight-rating"
                value={weight / 2} // Map 0-10 to 0-5
                onChange={handleChange}
                precision={0.5}
                max={5}
                icon={<CircleIcon fontSize="inherit" />}
                emptyIcon={<CircleOutlinedIcon fontSize="inherit" />}
            />
        </Box>
    );
};

export default WeightRating;